import type { Language } from "@sveabank/cc-common";

export const setBearerToken = (token: string) => {
	sessionStorage.setItem("BearerToken", token);
};

export const setRefreshToken = (token: string) => {
	sessionStorage.setItem("RefreshToken", token);
};

export const getBearerToken = () => sessionStorage.getItem("BearerToken") || "";

export const getRefreshToken = () => sessionStorage.getItem("RefreshToken") || "";
export const removeTokens = () => {
	sessionStorage.removeItem("revision");
	sessionStorage.removeItem("RefreshToken");
	sessionStorage.removeItem("BearerToken");
};

export const setRevision = (revision: string) => {
	sessionStorage.setItem("revision", revision);
};
export const getRevision = () => sessionStorage.getItem("revision") || "";

export const removeRevision = () => sessionStorage.removeItem("revision");

export const setStoredSsn = (ssn: string) => {
	localStorage.setItem("ssn", ssn);
};
export const getStoredSsn = () => localStorage.getItem("ssn") || "";
export const removeStoredSsn = () => {
	localStorage.removeItem("ssn");
};

export const getApplicationLanguage = (): Language => "sv";
